import { Entity } from '../../../models';

export enum CohortType {
  Department = 'Department',
  Team = 'Team',
  Role = 'Role',
  People = 'People',
}

export interface CohortData {
  entities: Entity[];
  totalPages: number;
  totalCount: number;
}

export interface ISelectCohortLayoutProps {
  supertitle?: string;
  title: string;
  subtitle?: string;
  cohortTypes?: CohortType[];
  selectedCohortType: CohortType;
  setSelectedCohortType: (cohortType: CohortType) => void;
  selectedEntity: Entity | undefined;
  setSelectedEntity: (entity: Entity | undefined) => void;
  onBack: () => void;
  onNext: () => void;
}
